import {
    PopoverContent,
    PopoverRoot,
    PopoverTrigger,
} from '@/src/common/components/elements/Buttons/Popover'
import { faInfo } from '@fortawesome/free-solid-svg-icons/faInfo'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Link from 'next/link'
import {
    LabelText,
    TextContainer,
    ValueText,
} from '@/src/modules/OrderStatus/StyledComponents'
import { FAQ_PAGE } from '../../pg-plus/constants'

interface ILineItemDetails {
    email?: string
    phone?: string
}

const LineItemDetailsVirtual = ({
    email = '',
    phone = '',
}: ILineItemDetails) => {
    return (
        <TextContainer data-testid={'line-item-details'}>
            <LabelText>To:</LabelText>
            &nbsp;
            <ValueText data-testid={'email'} className={'no-text-transform'}>
                {email} &nbsp;
                {phone} &nbsp;
                <PopoverRoot>
                    <PopoverTrigger variant={'default'}>
                        <FontAwesomeIcon icon={faInfo} />
                    </PopoverTrigger>
                    <PopoverContent>
                        For security purposes&#44; your recipient&#39;s email
                        address is intentionally obscured and not the correct
                        length. For more information, see our list of{' '}
                        <Link href={FAQ_PAGE} aria-label={'faq-button'}>
                            frequently asked questions
                        </Link>
                        .
                    </PopoverContent>
                </PopoverRoot>
            </ValueText>
        </TextContainer>
    )
}
export default LineItemDetailsVirtual
